import type { PrintSelectionPreviewRow } from "../../../../../../../_shared/_logic/print-selection-preview"
import type { PrintSelectionState, PrintSelectionValue } from "../print-selection-state"
import {
  isKeepPreconfigurationChoice,
  type PreconfigurationChoice,
} from "../../../../../../../../../../../../../_shared/_logic/preconfiguration-keep"

export type PrintSelectionPreconfigurationMode = "no" | "yes" | "necessary"

export type ApplyPrintSelectionPreconfigurationResult = {
  selection: PrintSelectionState
  changed: boolean
}

const preconfiguredValue = (
  row: PrintSelectionPreviewRow,
  mode: PrintSelectionPreconfigurationMode,
): PrintSelectionValue => {
  if (mode === "no") return "no"

  if (mode === "yes") return "yes"

  return row.recommended_print && row.printable ? "yes" : "no"
}

export const applyPrintSelectionPreconfiguration = ({
  selection,
  rows,
  mode,
}: {
  selection: PrintSelectionState
  rows: readonly PrintSelectionPreviewRow[]
  mode: PreconfigurationChoice<PrintSelectionPreconfigurationMode>
}): ApplyPrintSelectionPreconfigurationResult => {
  if (isKeepPreconfigurationChoice(mode)) return { selection, changed: false }

  let nextSelection: PrintSelectionState | null = null

  for (const row of rows) {
    const itemId = row.letter_delivery_batch_item_id
    const value = preconfiguredValue(row, mode)

    if (selection[itemId] === value) continue

    nextSelection ??= { ...selection }
    nextSelection[itemId] = value
  }

  return {
    selection: nextSelection ?? selection,
    changed: nextSelection !== null,
  }
}
